<template>
  <div>
    Wait for ranking selection
  </div>
</template>

<script>
  export default {
    name: "categoryDummy",
  }
</script>

<style scoped>

</style>
